import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
export function Hero() {
  return <div className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-16 pb-8" data-id="element-86">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-87">
        <img src="https://cdn.magicpatterns.com/uploads/a2Bnst1zYPLimQGBi5avRH/ChatGPT_Image_15_feb_2026,_09_53_29_p.m..png" alt="Teatro Background" className="w-full h-full object-cover" loading="eager" fetchPriority="high" decoding="sync" data-id="element-88" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-red-900/90" data-id="element-89" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white max-w-5xl flex flex-col items-center" data-id="element-90">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 backdrop-blur-sm border border-amber-400/50 rounded-full px-4 py-1.5 mb-4 animate-fade-in-up" data-id="element-91">
          <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-92" />
          <span className="text-amber-200 font-medium text-sm tracking-wide uppercase" data-id="element-93">
            The #1 Resource for Drama Teachers
          </span>
          <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-94" />
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-4 leading-tight drop-shadow-lg" data-id="element-95">
          The Ultimate Drama Teacher's Toolkit: <br data-id="element-96" />
          <span className="text-amber-400" data-id="element-97">2026 Edition</span>
        </h1>

        {/* Product Image Mockup */}
        <div className="relative w-full max-w-[220px] mx-auto mb-4" data-id="element-98">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-amber-500/20 blur-[80px] rounded-full opacity-50 animate-pulse-slow" data-id="element-99" />
          <img src="https://cdn.magicpatterns.com/uploads/xqGaBjG7c2d5dTJJEribQf/ChatGPT_Image_2_mar_2026,_12_09_46_p.m.-Photoroom.png" alt="Drama Teacher's Toolkit - Product Preview" className="relative z-10 w-full h-auto drop-shadow-2xl" loading="eager" decoding="async" fetchPriority="high" style={{
          animation: 'float 6s ease-in-out infinite',
          filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.6))'
        }} data-id="element-100" />
        </div>

        <p className="text-lg md:text-xl text-gray-200 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-101">
          Lesson plans, warm-up activities, and full production projects — ready
          to use in your classroom or workshop. Transform your classes today.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center w-full" data-id="element-102">
          <a href="#buy" className="w-full sm:w-auto" data-id="element-103">
            <Button size="lg" variant="primary" className="w-full sm:w-auto text-lg shadow-amber-900/20 px-8" data-id="element-104">
              Get Instant Access
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-105" />
            </Button>
          </a>
          <a href="#whats-included" className="w-full sm:w-auto" data-id="element-106">
            <Button size="lg" variant="secondary" className="w-full sm:w-auto text-lg bg-white/10 hover:bg-white/20 border-white/30 backdrop-blur-sm px-8" data-id="element-107">
              See What's Inside
            </Button>
          </a>
        </div>
      </div>

      {/* Decorative bottom curve */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0f172a] to-transparent z-0 pointer-events-none" data-id="element-108" />
    </div>;
}